module.exports = __webpack_public_path__ + "img/user.62f769fe.svg";